import React, { useState } from "react";
import { isAnyRDT } from "@coworker/reusable/helpers/devices";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { extractBasedOnSymbology } from "../../helpers/extractBasedOnSymbologyUtils";
import { SymbologyType } from "../../types/SymbologyType";
import styled from "styled-components";
import { useTranslation } from "@coworker/locales";
import SearchBarComponent from "../search-component/SearchBarComponent";
import { useHDIScanner } from "../../hooks/useHDIScanner";
import { BarcodeIcon } from "../scanner-ui-component/BarcodeIcon";
import { ProductSearchComponent } from "../../pages/product-search-page/ProductSearchComponent";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";

interface ScannerSearchComponentProps {
  handleProductSearchResult: (productNumber: string, itemType?: string) => void;
  handleCloseOfComponent: () => void;
  shouldHideSPRItems?: boolean;
  shouldHideLocalCombinationItems?: boolean;
}

const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: 0.5rem;
`;

const ScannerSearchComboComponent: React.FC<ScannerSearchComponentProps> = ({
  handleProductSearchResult,
  handleCloseOfComponent,
  shouldHideSPRItems = true,
  shouldHideLocalCombinationItems = true,
}) => {
  const handleScanResult = (
    scannedBarcode: string,
    symbology: SymbologyType
  ) => {
    const extractedBarcode = extractBasedOnSymbology(symbology, scannedBarcode);
    handleProductSearchResult(extractedBarcode.articleNumber);
  };
  const handleSearchResult = (product: Item) => {
    handleProductSearchResult(product.no, product.type);
  };
  const [shouldShowSearch, setShouldShowSearch] = useState(!isAnyRDT());
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();
  const readyToScanText = t("readyToScanString");

  const handleClose = () => {
    if (isAnyRDT() && shouldShowSearch) {
      setShouldShowSearch(false);
    } else {
      handleCloseOfComponent();
    }
  };

  useHDIScanner(handleScanResult);

  if (isAnyRDT() && !shouldShowSearch) {
    return (
      <PageContainer>
        <SearchBarComponent
          onSearchBarClick={() => setShouldShowSearch(true)}
          onCloseSearchClick={handleClose}
        />
        <BarcodeIcon readyToScanString={readyToScanText} scannerType={"hdi"} />
      </PageContainer>
    );
  }
  return (
    <ProductSearchComponent
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      itemCardRenderType={SearchItemCardRenderType.button}
      handleItemCardClick={handleSearchResult}
      handleClose={handleClose}
      shouldShowCloseButton={true}
      shouldHideSPRItems={shouldHideSPRItems}
      shouldHideLocalCombinationItems={shouldHideLocalCombinationItems}
    />
  );
};

export default ScannerSearchComboComponent;
